import { z } from "zod";
export const PublicCatalogOrganizationSchema = z.object({
    displayName: z.string(),
    timezone: z.string(),
});
export const PublicCatalogMoneySchema = z.object({
    amountMinor: z.number(),
    currency: z.string(),
});
export const PublicCatalogServiceSchema = z.object({
    id: z.number(),
    name: z.string(),
    duration: z.number(),
    provider: z.object({ id: z.number(), name: z.string() }),
    photoUrls: z.array(z.string()),
    startingPrice: PublicCatalogMoneySchema.nullable(),
    reviewSummary: z
        .object({ averageRating: z.number(), total: z.number() })
        .nullable(),
});
export const PublicCatalogSchema = z.object({
    organization: PublicCatalogOrganizationSchema,
    services: z.array(PublicCatalogServiceSchema),
});
